import { useUserDateRenderer } from '@issuemanager/apps/client/hooks';
import { useSessionContext } from '@issuemanager/apps/client/contexts';

interface Props {
  date?: Date | null;
}

export default function (props: Props) {
  const { timezone } = useSessionContext();
  const dateRenderer = useUserDateRenderer();
  return (
    <>
      <span>{`${dateRenderer.renderDateTime(props.date)}`}</span>
      <br />
      <span>{timezone}</span>
    </>
  );
}
